<script setup>
import RiskIcon from '@/Pages/Common/StatusIcon.vue';
import ACTION_TYPES from '@/Common/Enum/ActionType.js';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  title: String,
  actionType: Object
});

const tooltip = (() => {
  if (props.actionType === ACTION_TYPES.ACTION_RECOMMENDED) {
    return t(
      'domain_score.partials.detailed_report.explain_score_part.action_required'
    );
  } else if (props.actionType === ACTION_TYPES.ACTION_REQUIRED) {
    return t(
      'domain_score.partials.detailed_report.explain_score_part.action_recommended'
    );
  } else if (props.actionType === ACTION_TYPES.INFO) {
    return t(
      'domain_score.partials.detailed_report.explain_score_part.information'
    );
  }
  return t(
    'domain_score.partials.detailed_report.explain_score_part.no_action_required'
  );
})();
</script>

<template>
  <div
    class="mb-2 flex flex-col items-start gap-2 text-sm last:mb-0 md:flex-row md:items-start md:gap-0"
  >
    <div class="font-bold md:w-1/6">{{ title }}</div>
    <div class="flex flex-1 items-start">
      <RiskIcon
        class="mr-2 shrink-0"
        :action-type="actionType"
        v-tooltip="tooltip"
      />
      <div class="flex break-all">
        <slot />
      </div>
    </div>
  </div>
</template>
